@if (brand == 'prixtel') {
  <app-vitrine-menu></app-vitrine-menu>
}
@if (brand == 'coriolis') {
  <app-vitrine-menu-coriolis></app-vitrine-menu-coriolis>
}

<div [id]="'wrapper-' + brand" class="wpx_wrap">
  @if (brand == 'lacarte') {
    <a href="{{ vitrineUrl }}" class="logo"></a>
  }
  <app-breadcrumb [breadcrumb]="breadcrumbDetails" [brand]="brand"></app-breadcrumb>
</div>

<div [id]="'login-form-' + brand" class="row form_container">
  <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
    <div class="card card-signin my-5">
      <div class="card-body">
        <h1 class="card-title text-center blue-color">Première connexion</h1>
        Veuillez saisir votre numéro à 10 chiffres
        <br/><br/>
        <form class="form text-center" [formGroup]="firstConnexionForm" (ngSubmit)="send()">
          <div class="form-group">
            <label for="inputEmail" class="bold-label-text float-left">Votre numéro de téléphone*</label>
            <input type="text" id="inputEmail" class="form-control" placeholder="Votre numéro de téléphone" formControlName="msisdn" required>
            @if (firstConnexionFormSubmitted && firstConnexionForm.controls.msisdn.errors) {
              <p class="error-message">Veuillez entrer un numéro de téléphone valide.</p>
            }
          </div>
          <div class="bloc_cta">
            <button type="submit" class="cta_btn level_2">Recevoir le mot de passe par SMS<span></span></button>
          </div>
          Pour connaître votre numéro, veuillez appeler le 952
        </form>
      </div>
    </div>
  </div>
</div>

@if (brand == 'prixtel') {
  <app-vitrine-footer></app-vitrine-footer>
}
@if (brand == 'coriolis') {
  <app-vitrine-footer-coriolis></app-vitrine-footer-coriolis>
}
